import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import useOnboardingSx from '../../hooks/useOnboardingSx';
import { formatPermissionLabel } from '../../utils/permissionGrouping';
import PermissionModuleAccordion from './PermissionModuleAccordion';

export default function GeneralPermissionsPanel({
  modules = [],
  disabled = false,
  onChange,
}) {
  const sx = useOnboardingSx();

  if (!modules.length) return null;

  return (
    <>
      {modules.map((module, index) => (
        <PermissionModuleAccordion
          key={module.moduleKey}
          title={module.moduleLabel}
          enabledCount={module.enabledCount}
          totalCount={module.totalCount}
          defaultExpanded={index === 0}
        >
          {module.permissions.map((permission) => (
            <FormControlLabel
              key={permission.id}
              sx={sx.permissionRow}
              control={
                <Switch
                  size="small"
                  checked={!!permission.isAllowed}
                  disabled={disabled}
                  onChange={(event) => onChange(permission.id, event.target.checked)}
                />
              }
              label={
                <Typography variant="body2" color="text.primary">
                  {formatPermissionLabel(permission.name)}
                </Typography>
              }
            />
          ))}
        </PermissionModuleAccordion>
      ))}
    </>
  );
}
